import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _classCallCheck from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/inherits";
import { isAggregateOp } from '../../aggregate';
import { vgField } from '../../channeldef';
import { duplicate, hash as _hash } from '../../util';
import { unique } from '../../util';
import { DataFlowNode } from './dataflow';
/**
 * A class for the window transform nodes
 */

export var WindowTransformNode =
/*#__PURE__*/
function (_DataFlowNode) {
  _inherits(WindowTransformNode, _DataFlowNode);

  function WindowTransformNode(parent, transform) {
    var _this;

    _classCallCheck(this, WindowTransformNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowTransformNode).call(this, parent));
    _this.transform = transform;
    return _this;
  }

  _createClass(WindowTransformNode, [{
    key: "clone",
    value: function clone() {
      return new WindowTransformNode(null, duplicate(this.transform));
    }
  }, {
    key: "addDimensions",
    value: function addDimensions(fields) {
      this.transform.groupby = unique(this.transform.groupby.concat(fields), function (d) {
        return d;
      });
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      var _a, _b;

      var out = new Set();
      ((_a = this.transform.groupby) !== null && _a !== void 0 ? _a : []).forEach(out.add, out);
      ((_b = this.transform.sort) !== null && _b !== void 0 ? _b : []).forEach(function (m) {
        return out.add(m.field);
      });
      this.transform.window.map(function (w) {
        return w.field;
      }).filter(function (f) {
        return f !== undefined;
      }).forEach(out.add, out);
      return out;
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set(this.transform.window.map(this.getDefaultName));
    }
  }, {
    key: "getDefaultName",
    value: function getDefaultName(windowFieldDef) {
      var _a;

      return (_a = windowFieldDef.as) !== null && _a !== void 0 ? _a : vgField(windowFieldDef);
    }
  }, {
    key: "hash",
    value: function hash() {
      return "WindowTransform ".concat(_hash(this.transform));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      var _a;

      var fields = [];
      var ops = [];
      var as = [];
      var params = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.transform.window[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var window = _step.value;
          ops.push(window.op);
          as.push(this.getDefaultName(window));
          params.push(window.param === undefined ? null : window.param);
          fields.push(window.field === undefined ? null : window.field);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var frame = this.transform.frame;
      var groupby = this.transform.groupby;

      if (frame && frame[0] === null && frame[1] === null && ops.every(function (o) {
        return isAggregateOp(o);
      })) {
        // when the window does not rely on any particular window ops or frame, switch to a simpler and more efficient joinaggregate
        return Object.assign({
          type: 'joinaggregate',
          as: as,
          ops: ops,
          fields: fields
        }, groupby !== undefined ? {
          groupby: groupby
        } : {});
      }

      var sortFields = [];
      var sortOrder = [];

      if (this.transform.sort !== undefined) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = this.transform.sort[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var sortField = _step2.value;
            sortFields.push(sortField.field);
            sortOrder.push((_a = sortField.order) !== null && _a !== void 0 ? _a : 'ascending');
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
              _iterator2["return"]();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }

      var sort = {
        field: sortFields,
        order: sortOrder
      };
      var ignorePeers = this.transform.ignorePeers;
      return Object.assign(Object.assign(Object.assign({
        type: 'window',
        params: params,
        as: as,
        ops: ops,
        fields: fields,
        sort: sort
      }, ignorePeers !== undefined ? {
        ignorePeers: ignorePeers
      } : {}), groupby !== undefined ? {
        groupby: groupby
      } : {}), frame !== undefined ? {
        frame: frame
      } : {});
    }
  }]);

  return WindowTransformNode;
}(DataFlowNode);